<template lang="html">
<Tabs v-model="tabActive" animated swipeable type="line" title-inactive-color="#3b3b3b" title-tabActive-color="#fc2d2d" line-width="60">
    <Tab>
        <div slot="title">
            <span class="tab-name">
                商品详情
            </span>
            <em class="tab-line" v-if="tabActive == 0" />
            <span class="van-tab-middle-line"></span>
        </div>
        <div class="goodsDetailHtml" v-html="detail.goods.goods_detail"></div>
    </Tab>
    <Tab>
        <div slot="title">
            商品参数
            <em class="tab-line" v-if="tabActive == 1" />
        </div>
        <div class="goods-params">
            <div v-for="(item, index) in detail.goods.goods_params" :key="index">
                <span class="goods-params-name">{{ item.name }}</span>
                <span class="goods-params-value">{{ item.value }}</span>
            </div>
        </div>
    </Tab>
</Tabs>
</template>

<script>
import {
    Tabs,
    Tab
} from 'vant'
export default {
    name: 'deliveryGoodsBox',
    props: {
        // tabActive:{
        //     type: Number,
        //     default () {
        //         return 0
        //     }
        // },
        detail : {
            type: Object,
            default () {
                return {}
            }
        }
    },
    components: {
        Tabs,
        Tab
    },
    data () {
        return {
            tabActive: 0
        }
    }
}
</script>

<style  lang="stylus" scoped >
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
>>> .goodsDetailHtml
        width 100%
        overflow hidden
        img
            width 100%!important
            height auto!important
.goods-box
    background white
.goods-more
    img
      width 100%
    .goods-params
      padding 26px 30px
      div
        &:nth-last-child(1)
          span
            retinaBorder(
              ,
              false,
              false,
              true,
              false,
              1px,
              solid,
              $fcGreiest,
              0
            )
      span
        display inline-block
        padding 37px
        width 50%
        text-align center
        box-sizing border-box
        color $fcGrey
        retinaBorder(
          ,
          true,
          false,
          false,
          true,
          1px,
          solid,
          $fcGreiest,
          0
        )
        &:nth-last-child(1)
          retinaBorder(
            ,
            false,
            true,
            false,
            false,
            1px,
            solid,
            $fcGreiest,
            0
          )
      .goods-params-name
        padding 37px
        width 50%
        text-align center
</style>
